import Link from 'next/link';
import { Grid } from 'theme-ui';
import { useTranslation } from 'next-i18next';
import styles from '@features/cms/components/pages/SeeMoreProducts/SeeMoreProducts.styles';
import CategoriesProgressLine from '@features/categories/components/CategoriesProgressLine/CategoriesProgressLine';
type PropsType = {
  showMoreItems: boolean;
  loadedNumberProducts: number;
  maxCount: number;
  nextPageHref: string;
  handleShowMoreProducts: () => void;
};
const SeeMoreProducts = ({
  showMoreItems,
  loadedNumberProducts,
  maxCount,
  nextPageHref,
  handleShowMoreProducts
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  return <>
      <div sx={styles.progressLineSize}>
        <CategoriesProgressLine actualCount={loadedNumberProducts} maxCount={maxCount} />
      </div>
      {showMoreItems && <Grid columns={1} sx={styles.buttonCenter}>
          <Link href={nextPageHref} onClick={e => {
        e.preventDefault();
        handleShowMoreProducts();
      }} sx={styles.seeMoreButton} data-cy="VoxButtonPaginationNext">
            <span>{t('seeMore')}</span>
          </Link>
        </Grid>}
    </>;
};
export default SeeMoreProducts;